import { Link as LinkCore } from '@portals/core/src/components/Link/Link';
import { Breadcrumbs as BreadcrumbsCore } from '@portals/core/src/containers/Breadcrumbs/Breadcrumbs';
import Link from 'next/link';
import React, { ComponentProps, forwardRef, Ref } from 'react';

import { Page } from '../../../models';
import { useRequestHeaders } from '../../contexts/request-headers';

const publicHostPrefix = process.env.NEXT_PUBLIC_HOST_PREFIX || '';
interface Props {
  node: Page;
}

type LinkCoreProps = ComponentProps<typeof LinkCore>;

const NextLink = forwardRef<HTMLAnchorElement, LinkCoreProps>(
  ({ href, ...props }: LinkCoreProps, ref: Ref<HTMLAnchorElement>) => (
    <Link href={href} passHref legacyBehavior>
      <LinkCore ref={ref} {...props} />
    </Link>
  )
);

NextLink.displayName = 'NextLink';

export const Breadcrumbs: React.FC<Props> = ({ node }: Props) => {
  const { internalHost } = useRequestHeaders();
  const breadcrumbs = node.parents
    ?.filter((item) => !item.ignoreInBreadcrumb)
    .map((item) => {
      if (item.slugPath.endsWith('/')) {
        item['href'] = `${internalHost}${publicHostPrefix}${item.slugPath}`;
      } else {
        item['href'] = `${internalHost}${publicHostPrefix}${item.slugPath}.html`;
      }

      return item;
    })
    .reverse();
  if (!breadcrumbs?.length) {
    return null;
  }

  return <BreadcrumbsCore breadcrumbs={breadcrumbs} LinkComponent={NextLink} />;
};
